import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  innerCircle: [],
  innerCirclePagination: null,
  activityData: [],
  innerCircleData: null,
  innerCircleDetails: [],
  addUserData: null,
  circleListData: [],
  commentListData: [],
  globalListData: {}
};

const adminInnerCircleSlice = createSlice({
  name: 'adminInnerCircle',
  initialState,
  reducers: {
    adminInnerCircleLoad(state) {
      state.isLoading = true;
    },
    adminInnerCircleSuccess(state, action) {
      state.isLoading = false;
      state.innerCircle = action.payload; // Assuming action.payload is an array of innerCircle data
    },
    adminInnerCircleFail(state) {
      state.isLoading = false;
    },
    adminCreateActivityLoad(state) {
      state.isLoading = true;
    },
    adminCreateActivitySuccess(state, action) {
      state.isLoading = false;
      state.activityData = action.payload.data; // Assuming action.payload.data is an array of activity data
    },
    adminCreateActivityFail(state) {
      state.isLoading = false;
    },
    adminCreateInnerCircleLoad(state) {
      state.isLoading = true;
    },
    adminCreateInnerCircleSuccess(state, action) {
      state.isLoading = false;
      state.innerCircleData = action.payload.innerCircle; // Assuming action.payload.innerCircle is the innerCircle data object
    },
    adminCreateInnerCircleFail(state) {
      state.isLoading = false;
    },
    adminGetCircleListLoad(state) {
      state.isLoading = true;
    },
    adminGetCircleListSuccess(state, action) {
      state.isLoading = false;
      state.circleListData = action.payload; // Assuming action.payload is an array of circle list data
    },
    adminGetCircleListFail(state) {
      state.isLoading = false;
    },
    adminInnerCircleDetailLoad(state) {
      state.isLoading = true;
    },
    adminInnerCircleDetailSuccess(state, action) {
      state.isLoading = false;
      state.innerCircleDetails = action.payload; // Assuming action.payload is the innerCircle details data object
    },
    adminInnerCircleDetailFail(state) {
      state.isLoading = false;
    },
    adminAddUserinCircleLoad(state) {
      state.isLoading = true;
    },
    adminAddUserinCircleSuccess(state, action) {
      state.isLoading = false;
      state.addUserData = action.payload.data; // Assuming action.payload.data is the added user data
    },
    adminAddUserinCircleFail(state) {
      state.isLoading = false;
    },
    adminAddUserCircleLoad(state) {
      state.isLoading = true;
    },
    adminAddUserCircleSuccess(state, action) {
      state.isLoading = false;
      // You can update state as per your requirements here
    },
    adminAddUserCircleFail(state) {
      state.isLoading = false;
    },
    adminInnerCircleGlobalListLoad(state) {
      state.isLoading = true;
    },
    adminInnerCircleGlobalListSuccess(state, action) {
      state.isLoading = false;
      state.globalListData = action.payload; // Assuming action.payload is the global list data object
    },
    adminInnerCircleGlobalListFail(state) {
      state.isLoading = false;
    }
  }
});

export const {
  adminInnerCircleLoad,
  adminInnerCircleSuccess,
  adminInnerCircleFail,
  adminCreateActivityLoad,
  adminCreateActivitySuccess,
  adminCreateActivityFail,
  adminCreateInnerCircleLoad,
  adminCreateInnerCircleSuccess,
  adminCreateInnerCircleFail,
  adminGetCircleListLoad,
  adminGetCircleListSuccess,
  adminGetCircleListFail,
  adminInnerCircleDetailLoad,
  adminInnerCircleDetailSuccess,
  adminInnerCircleDetailFail,
  adminAddUserinCircleLoad,
  adminAddUserinCircleSuccess,
  adminAddUserinCircleFail,
  adminAddUserCircleLoad,
  adminAddUserCircleSuccess,
  adminAddUserCircleFail,
  adminInnerCircleGlobalListLoad,
  adminInnerCircleGlobalListSuccess,
  adminInnerCircleGlobalListFail
} = adminInnerCircleSlice.actions;

export default adminInnerCircleSlice.reducer;
